import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=7891757a&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"
import style0 from "./translate.vue?vue&type=style&index=0&id=7891757a&prod&scoped=true&lang=css"
import style1 from "./translate.vue?vue&type=style&index=1&id=7891757a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891757a",
  null
  
)

export default component.exports